import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CommonTitleIcon from "@/assets/img/eam/commonTitleIcon.png";
const ModuleHeader = ({ title, className = "", }) => {
    return (_jsx("div", { className: `relative w-full h-[0.47rem] ${className}`, style: {
            transformOrigin: "0 0",
        }, children: _jsxs("div", { className: "h-full absolute inset-0  relative overflow-hidden", style: {
                padding: 0,
                boxShadow: "inset 0 0 0 0.01rem transparent",
            }, children: [_jsx("div", { className: "absolute inset-0 z-0 flex items-center justify-center", style: {
                        height: "100%",
                        transform: "inherit",
                    }, children: _jsx("img", { src: CommonTitleIcon, style: {
                            width: "4.47rem",
                            height: "0.47rem",
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                        }, alt: "", className: "absolute inset-0", onError: () => { } }) }), _jsx("div", { className: "relative z-10 flex items-center", style: {
                        height: "100%",
                    }, children: _jsx("div", { className: "flex items-center h-full flex-shrink-0", children: _jsx("span", { className: "text-white font-bold text-lg tracking-wider drop-shadow-lg whitespace-nowrap", style: {
                                marginLeft: "0.40rem",
                                fontFamily: "Source Han Sans CN",
                                fontSize: "0.16rem",
                                display: "inline-flex",
                                alignItems: "center",
                            }, children: title }) }) })] }) }));
};
export default ModuleHeader;
